let showToastHandler = null;

export const registerGlobalToastHandler = (handler) => {
  showToastHandler = handler;

  return () => {
    if (showToastHandler === handler) {
      showToastHandler = null;
    }
  };
};

export const showGlobalToast = (message, severity = 'error') => {
  if (typeof showToastHandler === 'function') {
    showToastHandler({ message, severity });
  }
};
